import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import { useState, useEffect } from "react";
import {
  ChevronLeft,
  ChevronRight,
  Instagram,
  Youtube,
  Facebook,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import ExploreStyle from "../assets/stylesheets/ExploreHeader.module.css";
import { Logo } from "../assets/logo/Logo";
import Logger from "../utils/logger";
import { FarmExploreNav } from "../components/common/FarmExplore";

const log = Logger.create('Header');

const TikTok = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M16.6 5.82C15.9 5.06 15.5 4.08 15.5 3H12.4V16.94C12.4 18.6797 11.0797 20 9.34 20C7.6003 20 6.28 18.6797 6.28 16.94C6.28 15.2003 7.6003 13.88 9.34 13.88C9.89 13.88 10.41 14.04 10.86 14.3V11.03C10.36 10.92 9.84 10.87 9.32 10.87C6.04 10.87 3.38 13.54 3.38 16.81C3.38 20.08 6.04 22.75 9.32 22.75C12.6 22.75 15.26 20.08 15.26 16.81V9.66C16.45 10.56 17.91 11.09 19.46 11.09V8C19.46 8 17.75 8.11 16.6 5.82Z"
      fill="currentColor"
    />
  </svg>
);


export default function Header() {
  const navigate = useNavigate();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    let ticking = false;
    
    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const currentScrollY = window.scrollY;
          setIsScrolled(currentScrollY > 1);
          ticking = false;
        });
        ticking = true;
      }
    };

    const onResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onResize, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
    };
  }, []);

  return (
    <>
      <header
        className={`${ExploreStyle["explore-header"]} ${ExploreStyle["explore-home-header"]} ${
          isScrolled ? ExploreStyle.scrolled : ""
        }`}
      >
      <div 
        className={`${ExploreStyle["explore-header-container"]} ${ExploreStyle["explore-home-header-container"]}`}
      >
        <div className={ExploreStyle["explore-header-top"]}>
          {!isMobile && (
            <>
              <div className={ExploreStyle["explore-logo-container"]}>
                <a href="/" className={ExploreStyle["explore-logo-link"]}>
                  <Logo
                    className={ExploreStyle["explore-logo"]}
                    aria-label="FarmCiti Logo"
                  />
                </a>
              </div>
              <div className={ExploreStyle["explore-center-anim"]}>
                <div className={ExploreStyle["explore-explore-anim"]}>
                  <FarmExploreNav  />
                </div>
              </div>

              <div className={ExploreStyle["explore-social-links"]}>
                <a href="https://www.instagram.com/farmciti.ca" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <Instagram size={20} />
                </a>
                <a href="https://www.tiktok.com/@farmciti_canada" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                  <TikTok size={20} />
                </a>
                <a href="https://www.youtube.com/@FarmCitiCanada" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                  <Youtube size={20} />
                </a>
                <a href="https://www.facebook.com/people/FarmCiti/61573789681716/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <Facebook size={20} />
                </a>
              </div>
            </>
          )}
          
          {/* Mobile version - Search Button */}
          {isMobile && (
            <>
              <div className={ExploreStyle["explore-logo-container"]}>
                <a href="/" className={ExploreStyle["explore-logo-link"]}>
                  <Logo
                    className={ExploreStyle["explore-logo"]}
                    aria-label="FarmCiti Logo"
                  />
                </a>
              </div>
              <div className={ExploreStyle["explore-center-anim"]}>
                <div className={ExploreStyle["explore-explore-anim"]}>
                  <FarmExploreNav  />
                </div>
              </div>

            </>
          )}
        </div>


      </div>
    </header>
    
    {/* Mobile Navigation - positioned independently at bottom */}
    <div className={ExploreStyle["explore-mobile-header-container"]}>
      <nav className={ExploreStyle["explore-mobile-nav"]}>
        {/* Explore */}
        <Link
          to="/explore"
          className={ExploreStyle["explore-mobile-nav-item"]}
          aria-label="Explore"
        >
          <img
            src="/assets-temp/img/iconamoon_search.png"
            alt="Explore"
            className={ExploreStyle["explore-nav-icon"]}
          />

        </Link>

        {/* Home / Active */}
        <Link
          to="/"
          className={`${ExploreStyle["explore-mobile-nav-item"]} ${ExploreStyle["explore-active"]}`}
          aria-label="Home"
        >
          <img
            src="/assets-temp/img/logo-icon.png"
            alt="Home"
            className={ExploreStyle["explore-nav-icon"]}
          />
        </Link>

        </nav>
      </div>
    </>
  );
}
